<template>
  <div class="pa-5">
    <AppointmentCanceledInfo :appointment="appointment" />
    <AppointmentDivergenceInfo :appointment="appointment" />
    <AppointmentBasicInfo :appointment="appointment" />
    <AppointmentMeetingInfo :appointment="appointment" />
    <AppointmentRealties :appointment="appointment" />
    <AppointmentConfirmation :appointment="appointment" />
    <AppointmentHostAndVisitor :appointment="appointment" />
    <AppointmentOperator :appointment="appointment" />
    <AppointmentAdditionalInfo :appointment="appointment" />

    <AppointmentFilesTerm />

    <v-divider class="my-8" />

    <h2 class="mb-8">
      {{ $t('appointment.label.files') }}
      <v-btn
        v-if="appointmentFiles.length >= 1"
        @click="openModal('DELETE_ALL_APPOINTMENT_FILES')"
        elevation="0"
        class="ml-5"
        color="red"
        dark
        small
      >
        {{ $t('appointment.buttons.deleteAll') }}
      </v-btn>
      <v-btn
        v-if="appointmentFilesToDelete.length >= 1"
        @click="openModal('DELETE_SELECTED_APPOINTMENT_FILES')"
        elevation="0"
        class="ml-5"
        color="red"
        outlined
        small
      >
        {{ $t('appointment.buttons.deleteSelected') }}
      </v-btn>
    </h2>

    <AppointmentFilesUpload />

    <div v-if="hasOutputFiles">
      <v-divider class="my-8" />

      <h2 class="mb-8">
        {{ $t('appointment.label.outputs') }}
      </h2>

      <v-chip
        v-for="file in appointmentOutputs"
        :key="file.id"
        :href="file.url"
        color="grey lighten-3"
        target="_blank"
        class="mr-3 mb-3"
      >
        <strong>{{ file.name }}</strong>
      </v-chip>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import AppointmentHostAndVisitor from '@/components/appointment/details/AppointmentHostAndVisitor'
import AppointmentConfirmation from '@/components/appointment/details/AppointmentConfirmation'
import AppointmentCanceledInfo from '@/components/appointment/details/AppointmentCanceledInfo'
import AppointmentDivergenceInfo from '@/components/appointment/details/AppointmentDivergenceInfo'
import AppointmentMeetingInfo from '@/components/appointment/details/AppointmentMeetingInfo'
import AppointmentBasicInfo from '@/components/appointment/details/AppointmentBasicInfo'
import AppointmentOperator from '@/components/appointment/details/AppointmentOperator'
import AppointmentRealties from '@/components/appointment/details/AppointmentRealties'
import AppointmentAdditionalInfo from '@/components/appointment/details/AppointmentAdditionalInfo'

import AppointmentFilesUpload from '@/components/appointment/AppointmentFilesUpload'
import AppointmentFilesTerm from '@/components/appointment/AppointmentFilesTerm'

export default {
  name: 'AppointmentServiceDetails',

  components: {
    AppointmentHostAndVisitor,
    AppointmentCanceledInfo,
    AppointmentDivergenceInfo,
    AppointmentMeetingInfo,
    AppointmentBasicInfo,
    AppointmentOperator,
    AppointmentRealties,
    AppointmentFilesUpload,
    AppointmentFilesTerm,
    AppointmentConfirmation,
    AppointmentAdditionalInfo,
  },

  computed: {
    ...mapGetters([
      'appointment',
      'appointmentFiles',
      'appointmentOutputs',
      'appointmentFilesToDelete',
    ]),

    hasOutputFiles() {
      return this.appointmentOutputs.length >= 1
    }
  },

  methods: {
    ...mapActions(['openModal']),
  },
}
</script>
